'use client';

import Image from '@/components/Image';
import { useAppNavigation } from '@/hooks/useAppNavigation';
import { setSession } from '@/utils/tools';

interface BannerData {
  title: string;
  description_one?: string;
  description_two?: string;
  image?: string;
  imageUrl?: string;
  group?: string;
  btn_word?: string;
  aspectRatio?: string;
}

interface BannerProps {
  banner: BannerData;
  isMobile: boolean;
  onBannerExposure?: () => void;
  onBannerClick?: () => void;
}

export default function Banner({ banner, isMobile, onBannerExposure, onBannerClick }: BannerProps) {
  const { navigate } = useAppNavigation();

  // 根据设备类型确定宽高比
  const aspectRatio = banner.aspectRatio || (isMobile ? '375/560' : '1920/800');

  // 处理按钮点击跳转
  const handleButtonClick = () => {
    if (banner.group) {
      // 触发点击埋点
      onBannerClick?.();
      // 跳转到商品列表页
      setSession('zl_goodsListEnterPageScene', '活动专题页');
      navigate(`/goods-list/${banner.group}`);
    }
  };

  return (
    <div className="relative w-full banner-container" style={{ aspectRatio }}>
      <Image
        src={banner.image || banner.imageUrl || ''}
        alt={banner.title}
        width={isMobile ? 750 : 1920}
        height={isMobile ? 560 : 800}
        className="block w-full h-auto"
        onLoad={onBannerExposure} // 图片加载完成时触发曝光埋点
      />

      {/* Banner文字叠加 - PC端布局 */}
      {!isMobile && (
        <div className="absolute top-0 right-[215px] w-[470px] h-full flex flex-col justify-center text-white word-box">
          {banner.description_one && (
            <p className="text-[20px] mb-[8px]">{banner.description_one}</p>
          )}

          <h1 className="text-[56px] leading-[70px] font-bs mb-[12px]">{banner.title}</h1>

          {banner.description_two && (
            <p className="text-[12px] leading-[14px]">{banner.description_two}</p>
          )}

          {banner.group && banner.btn_word && (
            <button
              onClick={handleButtonClick}
              className="w-[280px] h-[48px] mt-[48px] leading-[50px] bg-white rounded-[28px] text-[16px] font-bs text-center text-black cursor-pointer"
              aria-label="zeelool eyewear"
            >
              {banner.btn_word}
            </button>
          )}
        </div>
      )}

      {/* Banner文字叠加 - 移动端布局 */}
      {isMobile && (
        <div className="absolute bottom-0 left-0 right-0 px-[24px] pb-[40px] text-white bg-gradient-to-t from-[#22232c] to-transparent word-box">
          {banner.description_one && (
            <p className="text-[12px] text-[#dedee1] mb-[8px]">{banner.description_one}</p>
          )}

          <h1 className="text-[32px] leading-[37px] font-bs mt-[12px]">{banner.title}</h1>

          {banner.description_two && (
            <p className="text-[12px] text-[#dedee1] leading-[21px] mt-[8px]">
              {banner.description_two}
            </p>
          )}

          {banner.group && banner.btn_word && (
            <button
              onClick={handleButtonClick}
              className="w-[240px] h-[40px] mt-[20px] bg-white rounded-[20px] leading-[42px] text-[12px] font-bs text-center text-[#01000e] cursor-pointer"
              aria-label="zeelool eyewear"
            >
              {banner.btn_word}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
